import app from '../app';
import { isSkipRentHelperTrapParamExists } from './rent-helper.service/utils';

// Название куки, где хранятся записи о закрытых попапах. По пользователям и GUID форм
const COOKIE_NAME = 'rentHelperBlock';

// Регионы, для которых показываем попап
const REGIONS_IN_EXPERIMENT = [
  1, // Мск
  2, // Спб
  4588, // Ленинградская область
  4593, // МО
  4596, // НН
  4618, // Татарстан
];

app.service('rentHelperService', ['$cookies', 'analyticsService', 'addFormService', 'config', 'store',
  function($cookies, analyticsService, addFormService, config, store) {
    // Входит ли регион пользователя в эксперимент?
    const isExperimentRegion = window && window.addFormState && window.addFormState.geo
      && REGIONS_IN_EXPERIMENT.includes(window.addFormState.geo.id);

    // Пользователь в эксперименте?
    const experimentName = config.get('dealRentTraps.experiment.name');
    const { abExperiments } = store.getState();
    const isInExperiment = abExperiments[experimentName] === '1';

    const isFeatureEnabled = window && window.runtime_settings && window.runtime_settings.addformRentHelperFeatureEnabled;

    // Для каждого объявения попап показывается только один раз, определяем GUId для черновика и объявления
    const objectGuid =
      window &&
      window.addFormState &&
      window.addFormState.offer &&
      window.addFormState.offer.objectGuid || window.addFormState.objectGuid;
    const draftObjectGuid =
      window &&
      window.addFormState &&
      window.addFormState.draft &&
      window.addFormState.draft.objectGuid;

    this.trapShown = false;

    this.isDealRentApplied = () => {
        return !!addFormService.ad?.dealRentData?.applyDealRentVersion;
    };

    this.isDealRentAvailable = () => {
      const result =
        addFormService.ad &&
        addFormService.ad.bargainTerms &&
        addFormService.ad.bargainTerms.leaseTermType === 'longTerm' &&
        addFormService.ad.isByHomeowner &&
        addFormService.ad.category === 'flatRent' &&
        !window.addFormState.hasDealRentState &&
        !addFormService.ad.hasDealRentState &&
        isFeatureEnabled &&
        isExperimentRegion;

        return result;
    };

    this.showRentHelperTrap = () => {
      const result =
        this.isDealRentAvailable() &&
        !this.isCookieExists() &&
        isInExperiment &&
        !this.isSkipRentHelperTrapParamExists();
      if (result && !this.trapShown) {
        analyticsService.trackRentHelperShow();
        this.trapShown = true;
      }
      return result;
    };

    /**
     * Проверяем, на этой форме уже показывался попап?
     * @returns {boolean}
     */
    this.isCookieExists = () => {

      let cookieValue = {};
      try {
        cookieValue = JSON.parse($cookies.get(COOKIE_NAME) || '{}');
      } catch (e) {
        throw new Error(e); // send to sentry
      }

      return !!(cookieValue[objectGuid] || cookieValue[draftObjectGuid]);
    };

    this.isSkipRentHelperTrapParamExists = isSkipRentHelperTrapParamExists;
}]);
